import {userAddressServiceRetrieve, userAddressServiceUpdate} from '../../api'

const serviceApiStore = {
  state: {
    selected: [],
    notes: '',
    addressIndex: 0,
    serviceYear: new Date().getFullYear(),
    lastModified: 0
  },
  getters: {
    springCleanup: state => {
      return state.selected.includes('springCleanup')
    },
    summerMaintenance: state => {
      return state.selected.includes('summerMaintenance')
    },
    fallCleanup: state => {
      return state.selected.includes('fallCleanup')
    },
    notes: state => {
      return state.notes
    },
    services: state => {
      return state.selected
    },
    serviceAddressIndex: state => {
      return state.addressIndex
    },
    serviceYear: state => {
      return state.serviceYear
    },
    serviceLastModified: state => {
      let timestamp = new Date(state.lastModifiedDate)
      return timestamp.toString()
    },
    service: (state, getters) => {
      let service = Object.assign({}, state)
      service.springCleanup = getters.springCleanup
      service.summerMaintenance = getters.summerMaintenance
      service.fallCleanup = getters.fallCleanup
      return service
    }
  },
  mutations: {
    /**
     * Update the selected services
     */
    updateSelectedServices (state, selected) {
      state.selected = selected
    },
    updateServiceLastModified (state, lastModified) {
      // TODO do we need to check the type provided for a Date vs a unix timestamp?
      state.lastModified = lastModified
    },

    /**
     * Update the addressIndexserviceYear combined field (service range key)
     */
    updateAddressIndexServiceYear (state, addressIndexserviceYear) {
      const parts = addressIndexserviceYear.split('-')

      if (parts.length !== 2) throw new Error('AddressIndex-ServiceYear incorrectly formatted')

      state.addressIndex = parts[0]
      state.serviceYear = parts[1]
    },

    /**
     * Update a selected service
     */
    updateServiceSelection (state, serviceStatus) {
      for (const key in serviceStatus) {
        if (serviceStatus[key]) {
          // service should be added
          state.selected.push(key)
        } else {
          // service should be removed
          const index = state.selected.indexOf(key)
          if (index >= 0) {
            state.selected.splice(index, 1)
          }
        }
      }
    },

    /**
     * Update the notes
     */
    updateNotes (state, notes) {
      state.notes = notes
    }
  },
  actions: {
    updateServiceState (context, data) {
      context.commit('updateSelectedServices', data.selected)
      context.commit('updateNotes', data.notes)
      context.commit('updateServiceLastModified', data.lastModified)
    },

    /**
     * Service retrieve API Method
     */
    serviceRetrieve (context) {
      const apiClient = context.getters.apiClient
      const userId = context.getters.userId
      const addressIndex = context.getters.serviceAddressIndex
      const serviceYear = context.getters.serviceYear

      return userAddressServiceRetrieve(apiClient, userId, addressIndex, serviceYear)
        .then((serviceInfo) => {
          context.dispatch('updateServiceState', serviceInfo)
          console.log('Retrieved service data: %j', serviceInfo)
          return serviceInfo
        })
        .catch((error) => {
          // TODO track the error message somewhere?
          throw error
        })
    },
    /**
     * Send updated service details
     */
    userServiceUpdate (context) {
      const apiClient = context.getters.apiClient
      const userId = context.getters.userId
      const serviceInfo = context.getters.service

      return userAddressServiceUpdate(apiClient, userId, serviceInfo)
        .then((serviceInfo) => {
          context.dispatch('updateServiceState', serviceInfo)
          console.log('Retrieved service data: %j', serviceInfo)
          return serviceInfo
        })
        .catch((error) => {
          // TODO track the error message somewhere?
          throw error
        })
    }
  }
}

export default serviceApiStore



// WEBPACK FOOTER //
// ./src/store/app/service.js